import { entity } from "simpler-state"

export const BulkWizardOpen = entity(false)

export function openBulkWizard() {
  BulkWizardOpen.set(true)
}

export function closeBulkWizard() {
  BulkWizardOpen.set(false)
}
